var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('active-forms-grid',{attrs:{"showBtns":_vm.showBtns,"returnUrl":'/forms/active'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }